<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="visible" width="90%" append-to-body>
    <template slot="title">
      <div class="doc-dialog-header">
        <span class="doc-dialog-title">{{ dialogTitle }}</span>
        <div v-if="showViewToolbar" class="doc-dialog-actions">
          <el-button-group>
            <el-button v-if="showSubmit" type="primary" size="small" :disabled="actionBusy" @click="submit">提交审批</el-button>
            <el-button v-if="showWfApprove" type="primary" size="small" :disabled="actionBusy" @click="wfApprove">审批通过</el-button>
            <el-button v-if="showWfReject" type="primary" size="small" :disabled="actionBusy" @click="wfReject">驳回</el-button>
            <el-button v-if="showApprove" type="primary" size="small" :disabled="actionBusy" @click="approveHandle">审核</el-button>
            <el-button v-if="showUnapprove" type="primary" size="small" :disabled="actionBusy" @click="unapproveHandle">弃审</el-button>
            <el-button v-if="showTrail" type="primary" size="small" @click="trailVisible = true">审批轨迹</el-button>
            <el-button v-if="isAuth('purchase:purchaseArrivalNotice:update')" type="primary" size="small" :disabled="!canEditDoc || actionBusy" @click="editFromView">修改</el-button>
            <el-button v-if="isAuth('purchase:purchaseArrivalNotice:delete')" type="primary" size="small" :disabled="!canEditDoc || actionBusy" @click="deleteHandle">删除</el-button>
          </el-button-group>
          <div v-if="workflowActionHint" class="wf-hint">{{ workflowActionHint }}</div>
        </div>
      </div>
    </template>
    <el-form ref="dataForm" :model="dataForm" :rules="formRules" label-width="100px" :disabled="formReadonly">
      <el-row>
        <el-col :span="6">
          <el-form-item label="通知单号" prop="noticeCode">
            <el-input v-model="dataForm.noticeCode" :readonly="codeReadonly || !!dataForm.noticeId" :placeholder="codeReadonly && !dataForm.noticeId ? '保存时自动生成' : ''" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="通知日期" prop="noticeDate">
            <el-date-picker v-model="dataForm.noticeDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="预计到货">
            <el-date-picker v-model="dataForm.expectedArrivalDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="供应商">
            <span>{{ dataForm.supplierName || '—' }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="采购订单" prop="purchaseOrderId">
            <el-select v-model="dataForm.purchaseOrderId" filterable :clearable="false" placeholder="选择已确认订单" style="width:100%" @change="onPurchaseOrderChange">
              <el-option
                v-for="item in purchaseOrderOptions"
                :key="item.purchaseOrderId"
                :label="item.purchaseOrderCode + ' / ' + item.supplierName"
                :value="item.purchaseOrderId"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注">
            <el-input v-model="dataForm.remark" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-table border :data="dataForm.lines" :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">
        <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
        <el-table-column prop="materialCode" label="产品编码" min-width="130" header-align="center" align="left" />
        <el-table-column prop="materialName" label="产品名称" min-width="130" header-align="center" align="left" />
        <el-table-column prop="specs" label="规格" min-width="100" header-align="center" align="left" />
        <el-table-column prop="orderQuantity" label="订购数量" width="90" header-align="center" align="left">
          <template slot-scope="scope">{{ formatQty(scope.row.orderQuantity) }}</template>
        </el-table-column>
        <el-table-column prop="remainQuantity" label="可通知" width="90" header-align="center" align="left">
          <template slot-scope="scope">{{ formatQty(scope.row.remainQuantity) }}</template>
        </el-table-column>
        <el-table-column prop="quantity" label="通知数量" width="180" header-align="center" align="left">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.quantity" :min="0" :max="formReadonly ? Math.max(Number(scope.row.quantity || 0), Number(scope.row.remainQuantity || 0)) : Number(scope.row.remainQuantity || 0)" :precision="2" style="width:100%" />
          </template>
        </el-table-column>
        <el-table-column v-if="!formReadonly" label="操作" width="70" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="removeLine(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button v-if="!formReadonly" type="primary" :disabled="submitLoading" @click="submitHandle">确定</el-button>
    </span>
    <workflow-trail-dialog :visible.sync="trailVisible" :workflow-instance="dataForm.workflowInstance" :tasks="trailTasks" />
  </el-dialog>
</template>

<script>
import WorkflowTrailDialog from '../../components/WorkflowTrailDialog.vue'
import request from '../../api/request'
import { docAction, docGet, docInfo, docSave } from '../../api/erp/doc'
import { fetchPerms } from '../../api/auth'
import { canShowDirectApproveButton, isWorkflowEditable, normalizeWorkflowDocUi, shouldShowWorkflowTrail } from '../../utils/workflow'

function today() {
  const d = new Date()
  const p = n => String(n).padStart(2, '0')
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
}

function blankForm(id) {
  return {
    noticeId: id || '',
    noticeCode: '',
    noticeDate: today(),
    expectedArrivalDate: '',
    purchaseOrderId: '',
    purchaseOrderCode: '',
    supplierId: '',
    supplierName: '',
    approveStatus: '0',
    workflowStatus: 'draft',
    workflowInstance: null,
    myPendingTask: null,
    workflowDocUi: null,
    remark: '',
    lines: []
  }
}

export default {
  name: 'PurchaseArrivalNoticeAddOrUpdate',
  components: { WorkflowTrailDialog },
  data() {
    return {
      visible: false,
      readonly: false,
      submitLoading: false,
      actionBusy: false,
      codeReadonly: false,
      workflowDocUiReady: false,
      trailVisible: false,
      purchaseOrderOptions: [],
      permCodes: [],
      dataForm: blankForm(),
      dataRule: {
        noticeCode: [{ required: true, message: '通知单号不能为空', trigger: 'blur' }],
        noticeDate: [{ required: true, message: '通知日期不能为空', trigger: 'change' }],
        purchaseOrderId: [{ required: true, message: '请选择采购订单', trigger: 'change' }]
      }
    }
  },
  computed: {
    formReadonly() {
      return this.readonly || this.dataForm.approveStatus === '2' || !this.canEditDoc
    },
    formRules() {
      const rules = { ...this.dataRule }
      if (this.codeReadonly) delete rules.noticeCode
      return this.formReadonly ? {} : rules
    },
    dialogTitle() {
      if (this.readonly) return '查看到货通知'
      return this.dataForm.noticeId ? '修改到货通知' : '新增到货通知'
    },
    showViewToolbar() {
      return this.readonly && !!this.dataForm.noticeId
    },
    workflowUi() {
      return normalizeWorkflowDocUi(this.dataForm.workflowDocUi)
    },
    canEditDoc() {
      return isWorkflowEditable(this.dataForm.workflowStatus, this.dataForm.approveStatus)
    },
    allowSaveDirectApprove() {
      const ui = this.workflowUi
      return !!(ui && ui.workflowEnabled && !ui.definitionMatched && ui.directApproveAllowed)
    },
    showApprove() {
      if (!this.showViewToolbar || !this.workflowDocUiReady) return false
      if (String(this.dataForm.approveStatus) === '2') return false
      if (!canShowDirectApproveButton(this.dataForm.workflowDocUi)) return false
      if (this.isAuth('purchase:purchaseArrivalNotice:approve')) return true
      return this.allowSaveDirectApprove && (this.isAuth('purchase:purchaseArrivalNotice:save') || this.isAuth('purchase:purchaseArrivalNotice:update'))
    },
    showUnapprove() {
      return this.showViewToolbar && this.isAuth('purchase:purchaseArrivalNotice:unapprove') && String(this.dataForm.approveStatus) === '2'
    },
    showSubmit() {
      const ui = this.workflowUi
      if (!this.showViewToolbar || !this.workflowDocUiReady || !ui || !ui.submitAllowed) return false
      const uid = (this.$store.state.user || {}).id
      if (this.dataForm.createBy && uid && String(this.dataForm.createBy) !== String(uid)) return false
      return this.isAuth('purchase:purchaseArrivalNotice:submit') || this.isAuth('purchase:purchaseArrivalNotice:save') || this.isAuth('purchase:purchaseArrivalNotice:update')
    },
    showWfApprove() {
      const task = this.dataForm.myPendingTask
      return this.showViewToolbar && this.isAuth('workflow:task:approve') && task && task.taskId
    },
    showWfReject() {
      return this.showWfApprove && this.isAuth('workflow:task:reject')
    },
    showTrail() {
      return shouldShowWorkflowTrail({
        inViewMode: this.showViewToolbar,
        workflowInstance: this.dataForm.workflowInstance,
        workflowDocUi: this.workflowUi,
        workflowDocUiReady: this.workflowDocUiReady
      })
    },
    trailTasks() {
      const inst = this.dataForm.workflowInstance
      return (inst && inst.tasks) || []
    },
    workflowActionHint() {
      const ui = this.workflowUi
      if (!ui || !ui.workflowEnabled || String(this.dataForm.approveStatus) === '2') return ''
      if (ui.inApproval) {
        const uid = (this.$store.state.user || {}).id
        const inst = this.dataForm.workflowInstance
        if (!(this.dataForm.myPendingTask && this.dataForm.myPendingTask.taskId) && inst && uid && String(inst.submitBy) === String(uid)) {
          return '当前步骤需由其他审批人处理（不允许提交人自审），请等待待办人审批。'
        }
        return ''
      }
      if (!ui.definitionMatched && ui.submitAllowed) return '已启用多级审批，尚未配置审批流程。请点击「提交审批」查看配置指引。'
      if (!ui.definitionMatched && ui.directApproveAllowed) return '已启用多级审批，尚未配置匹配的审批流程，可直接审核或联系管理员配置流程。'
      if (!ui.definitionMatched && !ui.directApproveAllowed && !ui.submitAllowed) return '已启用多级审批，请先在「审批流程定义」中配置到货通知流程后再提交。'
      return ''
    }
  },
  created() {
    fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {})
  },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      const role = String(user.roleCode || '')
      if (role === 'TENANT_ADMIN' || role === 'PLATFORM_ADMIN' || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    init(id, readonly) {
      this.readonly = !!readonly
      this.visible = true
      this.submitLoading = false
      this.actionBusy = false
      this.codeReadonly = !!id
      this.workflowDocUiReady = false
      this.dataForm = blankForm(id)
      this.$nextTick(() => {
        if (this.$refs.dataForm) this.$refs.dataForm.clearValidate()
      })
      if (!id) this.resolveCode()
      if (id) {
        docInfo('/purchase/purchaseArrivalNotice', id).then(res => {
          const body = res.data || {}
          this.dataForm = {
            ...blankForm(id),
            ...body,
            noticeDate: (body.noticeDate || '').slice(0, 10),
            expectedArrivalDate: body.expectedArrivalDate ? String(body.expectedArrivalDate).slice(0, 10) : '',
            lines: (body.lines || []).map(line => ({
              ...line,
              quantity: Number(line.quantity),
              remainQuantity: line.remainQuantity != null ? Number(line.remainQuantity) : Number(line.quantity),
              orderQuantity: line.orderQuantity != null ? Number(line.orderQuantity) : null
            }))
          }
          this.workflowDocUiReady = !!normalizeWorkflowDocUi(this.dataForm.workflowDocUi)
          this.loadPurchaseOrderOptions(body.purchaseOrderId)
        }).catch(() => {})
      } else {
        this.loadPurchaseOrderOptions()
      }
    },
    resolveCode() {
      request.post('/base/docNumberRule/resolve', { docType: 'purchaseArrivalNotice' }).then(res => {
        const data = res.data || {}
        this.codeReadonly = !!data.codeReadonly
        if (data.previewCode) this.dataForm.noticeCode = data.previewCode
        this.$nextTick(() => {
          if (this.$refs.dataForm) this.$refs.dataForm.clearValidate('noticeCode')
        })
      }).catch(() => {})
    },
    loadPurchaseOrderOptions(includePurchaseOrderId) {
      docGet('/purchase/purchaseArrivalNotice/ordersForNotice', {
        excludeNoticeId: this.dataForm.noticeId || '',
        includePurchaseOrderId: includePurchaseOrderId || ''
      }).then(res => {
        this.purchaseOrderOptions = res.data || []
      }).catch(() => {})
    },
    onPurchaseOrderChange(purchaseOrderId) {
      this.dataForm.lines = []
      const hit = this.purchaseOrderOptions.find(item => item.purchaseOrderId === purchaseOrderId)
      if (!purchaseOrderId || !hit) {
        this.dataForm.purchaseOrderCode = ''
        this.dataForm.supplierId = ''
        this.dataForm.supplierName = ''
        return
      }
      this.dataForm.purchaseOrderCode = hit.purchaseOrderCode
      this.dataForm.supplierId = hit.supplierId
      this.dataForm.supplierName = hit.supplierName
      if (!this.formReadonly) this.applyOrderLines(purchaseOrderId)
    },
    applyOrderLines(purchaseOrderId) {
      const orderId = purchaseOrderId || this.dataForm.purchaseOrderId
      if (!orderId) return
      docGet('/purchase/purchaseArrivalNotice/linesForNotice', {
        purchaseOrderId: orderId,
        excludeNoticeId: this.dataForm.noticeId || ''
      }).then(res => {
        const lines = res.data || []
        if (!lines.length) {
          this.$message.warning('该订单没有可通知明细')
          return
        }
        this.dataForm.lines = lines.map(line => ({
          purchaseOrderLineId: line.purchaseOrderLineId,
          materialId: line.materialId,
          materialCode: line.materialCode,
          materialName: line.materialName,
          specs: line.specs,
          orderQuantity: Number(line.quantity || 0),
          remainQuantity: Number(line.remainQuantity || 0),
          quantity: Number(line.remainQuantity != null ? line.remainQuantity : line.quantity || 0)
        }))
      }).catch(() => {})
    },
    removeLine(index) {
      this.dataForm.lines.splice(index, 1)
    },
    formatQty(val) {
      if (val == null || val === '') return '-'
      const n = Number(val)
      if (Number.isNaN(n)) return '-'
      return n.toLocaleString('zh-CN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
    },
    validateLines() {
      if (!this.dataForm.lines.length) return '请至少维护一条通知明细'
      if (this.dataForm.lines.find(line => !line.purchaseOrderLineId)) return '通知明细须来自采购订单'
      if (this.dataForm.lines.find(line => !(Number(line.quantity) > 0))) return '通知数量必须大于0'
      return ''
    },
    submitHandle() {
      const lineErr = this.validateLines()
      if (lineErr) {
        this.$message.error(lineErr)
        return
      }
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        const payload = {
          ...this.dataForm,
          expectedArrivalDate: this.dataForm.expectedArrivalDate || null,
          lines: this.dataForm.lines.map(line => ({
            purchaseOrderLineId: line.purchaseOrderLineId,
            materialId: line.materialId,
            quantity: line.quantity,
            remark: line.remark || ''
          }))
        }
        docSave('/purchase/purchaseArrivalNotice', payload, 'noticeId').then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {}).finally(() => { this.submitLoading = false })
      })
    },
    editFromView() {
      this.readonly = false
    },
    reloadNotice() {
      if (!this.dataForm.noticeId) return
      this.init(this.dataForm.noticeId, true)
    },
    approveHandle() {
      this.$confirm('审核后可下推来料检验或采购入库，是否继续?', '提示', { type: 'warning' }).then(() => {
        this.actionBusy = true
        docAction('/purchase/purchaseArrivalNotice', 'approve', { noticeId: this.dataForm.noticeId }).then(() => {
          this.$message.success('审核成功')
          this.$emit('refreshDataList')
          this.reloadNotice()
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    unapproveHandle() {
      this.$confirm('弃审前请确保无关联来料检验或采购入库单，是否继续?', '提示', { type: 'warning' }).then(() => {
        this.actionBusy = true
        docAction('/purchase/purchaseArrivalNotice', 'unapprove', { noticeId: this.dataForm.noticeId }).then(() => {
          this.$message.success('弃审成功')
          this.$emit('refreshDataList')
          this.reloadNotice()
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    deleteHandle() {
      this.$confirm('确定删除该单据?', '提示', { type: 'warning' }).then(() => {
        this.actionBusy = true
        docAction('/purchase/purchaseArrivalNotice', 'delete', { noticeId: this.dataForm.noticeId }).then(() => {
          this.$message.success('删除成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    submit() {
      const ui = this.workflowUi
      if (ui && ui.workflowEnabled && !ui.definitionMatched) {
        this.$alert('尚未配置到货通知审批流程，请先在「审批流程定义」中新增并启用流程（至少一个审批步骤）后再提交。', '未配置审批流程', { type: 'warning', confirmButtonText: '我知道了' })
        return
      }
      this.$confirm('提交后将进入审批流程，期间不可修改，是否继续?', '提示', { type: 'warning' }).then(() => {
        this.actionBusy = true
        request.post('/workflow/submit', { bizType: 'purchaseArrivalNotice', bizId: this.dataForm.noticeId }).then(() => {
          this.$message.success('提交成功')
          this.reloadNotice()
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    wfApprove() {
      const task = this.dataForm.myPendingTask
      if (!task || !task.taskId) return
      this.$prompt('审批意见（可选）', '审批通过', { inputType: 'textarea', confirmButtonText: '通过' }).then(({ value }) => {
        this.actionBusy = true
        request.post('/workflow/task/approve', { taskId: task.taskId, comment: value || '' }).then(() => {
          this.$message.success('审批通过')
          this.$emit('refreshDataList')
          this.reloadNotice()
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    wfReject() {
      const task = this.dataForm.myPendingTask
      if (!task || !task.taskId) return
      this.$prompt('请输入驳回原因', '审批驳回', {
        inputType: 'textarea',
        confirmButtonText: '驳回',
        inputValidator: v => !!(v && String(v).trim()) || '驳回原因不能为空'
      }).then(({ value }) => {
        this.actionBusy = true
        request.post('/workflow/task/reject', { taskId: task.taskId, comment: String(value).trim() }).then(() => {
          this.$message.success('已驳回')
          this.$emit('refreshDataList')
          this.reloadNotice()
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.doc-dialog-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; padding-right: 28px; }
.doc-dialog-title { font-size: 16px; font-weight: 600; line-height: 32px; }
.doc-dialog-actions { display: flex; flex-direction: column; align-items: flex-end; }
.doc-dialog-actions >>> .el-button-group { display: flex; flex-wrap: wrap; }
.wf-hint { margin-top: 6px; color: #e6a23c; font-size: 12px; line-height: 1.4; }
</style>
